import React from 'react'
import AuditDataListfromApi from '../../../GlobalComponents/AuditDataListfromApi'

export default function DebitSummery() {
  return (
   
      <div
        style={{
          borderRadius: '4px',
          background:'#42a1ad',
        }}
      >
       <AuditDataListfromApi
        endpoint="/debit"
        headerText="Debit Data Report"
              />
      </div>
    
  )
}

 

 